import React, { useCallback, useEffect, useMemo, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import Sidebar from '../components/Sidebar';
import './BayBoard.css';

function BayBoard({ onLogout }) {
  const navigate = useNavigate();
  const [bays, setBays] = useState([]);
  const [summary, setSummary] = useState({ total: 75, occupied: 0, free: 75 });
  const [loading, setLoading] = useState(true);
  const [message, setMessage] = useState('');

  const token = localStorage.getItem('token');
  const auth = useMemo(() => ({ headers: { Authorization: `Bearer ${token}` } }), [token]);

  const loadBays = useCallback(async () => {
    setLoading(true);
    setMessage('');

    try {
      const response = await axios.get('/api/bays', auth);
      setBays(response.data.bays || []);
      setSummary(response.data.summary || { total: 75, occupied: 0, free: 75 });
    } catch (error) {
      setMessage(error.response?.data?.message || 'Failed to load bay board.');
    } finally {
      setLoading(false);
    }
  }, [auth]);

  useEffect(() => {
    loadBays();
  }, [loadBays]);

  const openJobCard = (bay) => {
    if (bay?.IsOccupied && bay?.JobCardId) {
      navigate(`/jobcards/${bay.JobCardId}/edit`);
      return;
    }

    if (bay?.BayId) {
      navigate(`/jobcards/new?bayId=${encodeURIComponent(bay.BayId)}`);
    }
  };

  return (
    <div className="home-container">
      <Sidebar onLogout={onLogout} />
      <main className="bay-board-page">
        <header className="bay-board-header app-page-header">
          <div className="app-title-group">
            <button className="app-back-button" onClick={() => navigate('/')} aria-label="Back to home">
              Back
            </button>
            <div className="app-title-copy">
            <h1>Bay Board</h1>
            <p>Workshop capacity: {summary.occupied} busy, {summary.free} free, {summary.total} total</p>
            </div>
          </div>
          <div className="bay-board-actions app-header-actions">
            <button type="button" onClick={loadBays}>Refresh</button>
            <button type="button" onClick={() => navigate('/jobcards/new')} disabled={summary.free <= 0}>
              New Job Card
            </button>
          </div>
        </header>

        <section className="bay-board-legend">
          <span><i className="legend-dot free" /> Free</span>
          <span><i className="legend-dot busy" /> Busy</span>
        </section>

        {message && <div className="bay-board-message">{message}</div>}

        {loading ? (
          <div className="bay-board-loading">Loading bays...</div>
        ) : (
          <section className="bay-grid" aria-label="Workshop bay status">
            {bays.map((bay) => (
              <button
                key={bay.BayId}
                type="button"
                className={`bay-tile ${bay.IsOccupied ? 'busy' : 'free'}`}
                onClick={() => openJobCard(bay)}
                title={bay.IsOccupied ? `Open Job Card #${bay.JobNumber}` : `Create Job Card in Bay ${String(bay.BayNumber).padStart(2, '0')}`}
              >
                <span className="bay-number">{String(bay.BayNumber).padStart(2, '0')}</span>
                <span className="bay-type">{bay.BayType || 'General'}</span>
                <span className="bay-status">{bay.IsOccupied ? 'Busy' : 'Free'}</span>
                {bay.IsOccupied && (
                  <span className="bay-detail">
                    #{bay.JobNumber || bay.JobCardId}
                    <small>{bay.CarNumber || 'No plate'}</small>
                  </span>
                )}
              </button>
            ))}
          </section>
        )}
      </main>
    </div>
  );
}

export default BayBoard;
